<template>
  <div class="evaluateWtapper">
    <div
      class="evaluateItem acea-row"
      v-for="(item, index) in reply"
      :key="index"
    >
      <div class="pictrue">
        <img
          v-if="!item.anonymous"
          :src="item.avatar || '@/assets/img/home_f1.png'"
          class="image"
        />
        <img v-else src="@/assets/img/home_f1.png" class="image" />
      </div>
      <div class="right">
        <div class="name line1">
          {{ item.anonymous ? "匿名" : item.nickname }}
        </div>
        <div class="evaluate-infor">
          {{ item.comment || "默认好评" }}
        </div>
        <div class="imgList acea-row">
          <div
            class="pictrue"
            v-for="(itemn, index) in item.picturesArr"
            :key="index"
          >
            <img :src="itemn" class="image" />
          </div>
        </div>
        <div class="time">{{ item.createTime }}</div>
        <div
          class="edit-evaluate"
          v-if="item.isEdit"
          @click="
            $router.push({
              path: '/goods_evaluate/' + item.unique,
              query: { type: 'edit', id: item.id },
            })
          "
        >
          重新评价
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "UserEvaluation",
  props: {
    reply: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.evaluateWtapper {
  padding: 0 0.24rem;
  .evaluateItem {
    margin-bottom: 0.25rem;
    .pictrue {
      width: 1.05rem;
      height: 1.05rem;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.2rem;
    }
    .image {
      width: 100%;
    }
    .name {
      font-size: 0.3rem;
      font-weight: 600;
    }
    .evaluate-infor {
      line-height: 0.4rem;
      margin-top: 0.19rem;
      color: #333333;
    }
    .right {
      flex: 1;
      padding-bottom: 0.3rem;
      border-bottom: 1px solid #0ce6df;
      .edit-evaluate {
        text-align: right;
        font-size: 0.25rem;
        color: #0ce6df;
      }
    }
  }
}
</style>
